import { appStore, useAppDispatch, useAppSelector } from '@/store'
import type { ModalType } from '@/store/app'
import { setModal } from '@/store/app'
import { useCallback } from 'react'

export const useModal = () => {
  const dispatch = useAppDispatch()
  const { modalOpened } = useAppSelector(appStore)

  const showModal = useCallback(
    (name: ModalType) => {
      dispatch(setModal(name))
    },
    [dispatch]
  )

  const hideModal = useCallback(() => {
    dispatch(setModal(null))
  }, [dispatch])

  return { modalOpened, showModal, hideModal }
}
